import Vue from "vue";
import VueRouter from "vue-router";
import VueStore from "../store/index";
import { USER_GET } from "../store/actions/user";

Vue.use(VueRouter);

const routes = [
    {
        path: "/home",
        name: "home",
        component: () => import("../views/Home.vue"),
    },
    {
        path: "/login",
        name: "login",
        component: () => import("../views/Login.vue"),
        meta: {
            auth: false,
        },
    },
    {
        path: "/logout",
        name: "logout",
        component: () => import("../views/Logout.vue"),
    },
    {
        path: "/create",
        name: "create",
        component: () => import("../views/Create.vue"),
        props: true,
    },
    {
        path: "/projects/:id",
        name: "project.wrapper",
        component: () => import("../views/project/Wrapper.vue"),
        props: true,
        children: [
            {
                path: "/projects/:id/details",
                name: "project.details",
                component: () => import("../views/project/Details.vue"),
                props: true,
            },
            {
                path: "/projects/:id/prizes",
                name: "project.prizes",
                component: () => import("../views/project/Prizes.vue"),
                props: true,
            },
            {
                path: "/projects/:id/products",
                name: "project.products",
                component: () => import("../views/project/Products.vue"),
                props: true,
            },
            {
                path: "/projects/:id/report",
                name: "project.report",
                component: () => import("../views/project/Report.vue"),
                props: true,
            },
        ],
    },
];

const router = new VueRouter({
    base: process.env.BASE_URL,
    routes,
});

router.beforeEach(async (to, from, next) => {
    if (to.meta.auth === false) {
        next();
        return;
    }

    const user = VueStore.state.user;
    if (!user.isAuthenticated) {
        await VueStore.dispatch(USER_GET);
        if (!user.isAuthenticated && router.currentRoute.name !== "login") {
            next({ name: "login" });
        }
    }

    next();
});

export default router;
